import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {FlexContainer} from 'app/styles/content';
import {LinkOnComponent} from 'app/components/links/link';
import {Card, Football, FuPaPlayer} from 'app/components/icons';
import {Group, Star} from '@mui/icons-material';

const types = {
  '1': [COLORS.fupaPrimary, COLORS.white, COLORS.fupaPrimaryFocused],
  '2': [COLORS.lightGrey, COLORS.fupaPrimary, COLORS.grey],
  '3': [COLORS.fupaSecondary, COLORS.white, COLORS.fupaSecondaryFocused],
};

const Container = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${SIZES['96']};
  background-color: ${props => (props.type ? types[props.type][0] : COLORS.fupaPrimary)};

  :hover {
    background-color: ${props => (props.type ? types[props.type][2] : COLORS.fupaPrimaryFocused)};
  }
`;

const Title = styled(Typography)`
  &&& {
    color: ${props => (props.type ? types[props.type][1] : COLORS.white)};
  }
  line-height: ${SIZES['24']};
  padding-top: ${SIZES['4']};
  text-align: center;
`;

const Tile = ({label, type, icon, link, ...props}) => {
  const iconStyle = {color: type ? types[type][1] : COLORS.white, fontSize: 32};
  let displayedIcon = null;
  switch (icon) {
    case 'football':
      displayedIcon = <Football style={iconStyle} />;
      break;
    case 'group':
      displayedIcon = <Group style={iconStyle} />;
      break;
    case 'star':
      displayedIcon = <Star style={iconStyle} />;
      break;
    case 'yellow':
      displayedIcon = <Card style={iconStyle} />;
      break;
    default:
      displayedIcon = <FuPaPlayer style={iconStyle} />;
  }

  return (
    <LinkOnComponent to={link} {...props}>
      <Container type={type}>
        {displayedIcon}
        <Title variant='subheading2' component='span' type={type}>
          {label}
        </Title>
      </Container>
    </LinkOnComponent>
  );
};

export default Tile;
